import { FC } from 'react'
import createStandardIcon from './createStandardIcon'
import type { IconProps } from './type'

const LocationIconSvg: FC<IconProps> = (props) => {
  const { color, fill } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17" {...props}>
      <mask
        id="mask0_155_4208"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="17"
      >
        <rect y="0.5" width="16" height="16" fill={fill} />
      </mask>
      <g mask="url(#mask0_155_4208)">
        <path
          d="M8.00002 13.5088C9.30424 12.3413 10.3023 11.2214 10.9942 10.1492C11.6861 9.07695 12.032 8.13784 12.032 7.33184C12.032 6.1165 11.6459 5.11739 10.8737 4.3345C10.1015 3.55162 9.14357 3.16017 8.00002 3.16017C6.85646 3.16017 5.89857 3.55162 5.12635 4.3345C4.35413 5.11739 3.96802 6.1165 3.96802 7.33184C3.96802 8.13784 4.31396 9.07695 5.00585 10.1492C5.69774 11.2214 6.6958 12.3413 8.00002 13.5088ZM8.00002 14.46C7.87013 14.46 7.74024 14.4376 7.61035 14.3928C7.48035 14.3479 7.3628 14.2785 7.25768 14.1845C6.65946 13.6332 6.09963 13.0654 5.57818 12.4812C5.05685 11.8971 4.60368 11.3131 4.21868 10.7293C3.83357 10.1456 3.52885 9.56695 3.30452 8.9935C3.08018 8.41995 2.96802 7.86606 2.96802 7.33184C2.96802 5.79339 3.46563 4.54789 4.46085 3.59534C5.45618 2.64278 6.63591 2.1665 8.00002 2.1665C9.36413 2.1665 10.5438 2.64278 11.5392 3.59534C12.5344 4.54789 13.032 5.79339 13.032 7.33184C13.032 7.86606 12.9199 8.41884 12.6955 8.99017C12.4712 9.56162 12.1676 10.1403 11.7847 10.7262C11.4017 11.3121 10.9495 11.896 10.4282 12.478C9.90685 13.0601 9.34702 13.6268 8.74868 14.178C8.64513 14.272 8.52741 14.3425 8.39552 14.3895C8.26374 14.4365 8.13191 14.46 8.00002 14.46ZM8.00118 8.41C8.33285 8.41 8.61641 8.29189 8.85185 8.05567C9.08741 7.81945 9.20518 7.5355 9.20518 7.20384C9.20518 6.87217 9.08707 6.58856 8.85085 6.353C8.61463 6.11756 8.33063 5.99984 7.99885 5.99984C7.66718 5.99984 7.38363 6.11795 7.14818 6.35417C6.91263 6.59039 6.79485 6.87439 6.79485 7.20617C6.79485 7.53784 6.91296 7.82139 7.14918 8.05684C7.38541 8.29228 7.66941 8.41 8.00118 8.41Z"
          fill={fill}
        />
      </g>
    </svg>
  )
}

export const LocationIcon = createStandardIcon(LocationIconSvg)
